import { createContext, useContext } from "react"

import { CardsViewContextValues } from "./CardsView.types"

export const CardsViewContext = createContext<CardsViewContextValues | undefined>(undefined)
CardsViewContext.displayName = "CardsView"

export default function useCardsView(): CardsViewContextValues {
    const context = useContext(CardsViewContext)
    if (!context) {
        throw new Error("useCardsView must be used within a CardsView.Provider component")
    }

    return context
}
